<template>
  <div
    class="content_box xincon"
    style="background-color: #f5f6fa;    display: flex;
    flex-direction: column;"
  
  >
    <hear></hear>
    <div style="flex:1;" class="content">
      <el-tabs :tab-position="tabPosition">
        <el-tab-pane label="正在进行">
          <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="等待审核" name="first">
              <shenhe></shenhe
            ></el-tab-pane>
            <el-tab-pane label="等待出函" name="firsts">
              <shenhes></shenhes
            ></el-tab-pane>
            <!-- <el-tab-pane label="审核拒绝" name="second"> <jujue></jujue></el-tab-pane>
            <el-tab-pane label="已经出函" name="third"> <chuhan></chuhan></el-tab-pane>
            <el-tab-pane label="已经过期" name="fourth"> <guoqi></guoqi></el-tab-pane> -->
          </el-tabs>
          <!-- <tiaohz></tiaohz> -->
        </el-tab-pane>
        <el-tab-pane label="保函列表">
          <el-tabs type="card" v-model="activeNames" @tab-click="handleClick">
            <el-tab-pane label="审核拒绝" name="second">
              <jujue></jujue
            ></el-tab-pane>
            <el-tab-pane label="已经出函" name="third">
              <chuhan></chuhan
            ></el-tab-pane>
            <el-tab-pane label="已经过期" name="fourth">
              <guoqi></guoqi
            ></el-tab-pane>
          </el-tabs>
          <!-- <tiaohz></tiaohz> -->
        </el-tab-pane>
        <el-tab-pane label="工程列表">
          <list></list>
        </el-tab-pane>
        <el-tab-pane label="续保申请">
          <xubao></xubao>
        </el-tab-pane>
        <el-tab-pane label="解保申请">
          <jeibao></jeibao>
        </el-tab-pane>
        <el-tab-pane label="放弃保函">
          <fangqi></fangqi>
        </el-tab-pane>
      </el-tabs>

      <!-- <el-tabs :tab-position="tabPosition">
       <el-tab-pane label="审核中">
          <shenhe></shenhe>
        </el-tab-pane>
        <el-tab-pane label="已拒绝">
          <jujue></jujue>
        </el-tab-pane>
            <el-tab-pane label="已出函">
          <chuhan></chuhan>
        </el-tab-pane>
            <el-tab-pane label="已过期">
          <guoqi></guoqi>
        </el-tab-pane>
      </el-tabs> -->
    </div>
    <binad></binad>
  </div>
</template>

<script>
import binad from ".././../components/dinad.vue";
import hear from "@/components/hear.vue";
// import cioand from "@/view/Guarantee/cioands.vue";
// import tiaohz from "@/view/Guarantee/tiaohz.vue";
import shenhe from "@/view/Guarantee/shenhe.vue";
import shenhes from "@/view/Guarantee/shenhes.vue";
import jujue from "@/view/Guarantee/jujue.vue";
import chuhan from "@/view/Guarantee/chuhan.vue";
import guoqi from "@/view/Guarantee/guoqi.vue";
import list from "@/view/daihouguanli/list.vue";
import xubao from "@/view/daihouguanli/xubaoList.vue";
import jeibao from "@/view/daihouguanli/jiebaoList.vue";
import fangqi from "@/view/daihouguanli/fangqiList.vue";
import {
  kuaidi,
  ziliao,
  bhlist,
  bh_detail,
  fapiao,
  password,
  logou,
  shenqingkaipiao
} from "@/api/system/usercenter.js";
export default {
  components: {
    hear,
    // cioand,
    guoqi,
    chuhan,
    jujue,
    shenhe,
    shenhes,
    // tiaohz,
    binad,
    list,
    xubao,
    jeibao,
    fangqi
  },
  data() {
    return {
      tabPosition: "left",
      activeNames: "third", // 快递参数
      kuaidi_params: {
        limit: 10,
        offset: 0
      },
      // 快递总条数
      kuaidi_total: null,
      baohan_total: null,
      activeName: "first",
      // 快递列表
      kuaidilist: [],
      jigouName: "",
      jigouNames: "",
      // 个人资料
      ziliaolist: {},
      labelPosition: "top",
      // 保函列表
      Bh_list: [],
      // 保函详情参数
      Bh_details: {
        offset: 0,
        limit: 10
      },
      // 保函详情内容
      Bh_content: {},
      // 保函总条数
      Bh_total: null,
      // 发票参数
      fapiao_params: {
        offset: 0,
        limit: 10,
        keywords: ""
        // user_id: sessionStorage.getItem("user_id"),
      },
      baohan_params: {
        offset: 0,
        limit: 10,
        keywords: ""
        // user_id: sessionStorage.getItem("user_id"),
      },
      weidaili_search: "",
      // 发票总条数
      fapiao_total: null,
      // 发票列表容器
      fapiaolist: [],
      // 修改密码参数
      form: {
        password: "",
        old_password: ""
      },
      password_again: ""
    };
  },
  mounted() {
    this.getBhlist();
    this.getBhdetail();
    this.getFapiao();
  },
  methods: {
    // 获取快递列表

    handleSizeChange_baohan(val) {
      this.Bh_details.limit = val;
      this.getBhlist();
    },

    handleCurrentChange_baohan(val) {
      this.Bh_details.offset = parseInt(val - 1) * this.Bh_details.limit;
      this.getBhlist();
    },
    handleAdd() {
      console.log(123);
    },

    // 获取保函列表
    getBhlist() {
      bhlist(this.Bh_details).then(res => {
        if (res.data.code == 1) {
          this.Bh_list = res.data.data.rows;
          this.Bh_total = res.data.data.total;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    // 获取保函详情 点击详情按钮
    getBhdetail() {
      let bh_id = 1;
      bh_detail({ bh_id }).then(res => {
        if (res.data.code == 1) {
          this.Bh_content = res.data.data.jiben;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    handleSizeChange_bh(val) {
      this.Bh_details.limit = val;
      this.getBhlist();
    },
    handleCurrentChange_bh(val) {
      this.Bh_details.offset = parseInt(val - 1) * 10;
      this.getBhlist();
    },
    // 获取发票列表
    getFapiao() {
      fapiao(this.fapiao_params).then(res => {
        if (res.data.code == 1) {
          this.fapiaolist = res.data.data.rows;
          console.log("发票列表", this.fapiaolist);

          this.fapiao_total = res.data.data.total;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    // 申请发票
    handleshenqing(id) {
      shenqingkaipiao({ user_id: sessionStorage.getItem("user_id"), id }).then(
        res => {
          if (res.data.code == 1) {
            this.$message.success("申请成功");
            this.getFapiao();
          } else {
            this.$message.error(res.data.msg);
          }
        }
      );
    },
    handleSizeChange(val) {
      this.fapiao_params.limit = val;
      this.getFapiao();
    },
    handleCurrentChange(val) {
      this.fapiao_params.offset = parseInt(val - 1) * 10;
      this.getFapiao();
    },
    handleSearch() {
      this.fapiao_params.keywords = this.weidaili_search;
      this.getFapiao();
    }
  }
};
</script>
<style>
.xincon .el-tabs__content{
  height: 100%;
}
.xincon .el-tab-pane{
  height: 100%;
}
.xincon .el-tabs--top{
  height: 100%;
  display: flex;
    flex-direction: column;
}
</style>
<style scoped lang="scss">
.update_password {
  width: 100%;
  display: flex;
  justify-content: center;
  .update {
    width: 30%;
  }
}
::v-deep.el-form--inline .el-form-item {
  width: 100%;
}
::v-deep.el-form--inline .el-form-item__content {
  width: 100%;
}
.search {
  float: right;
  width: 20%;
  margin: 10px 0 10px 0;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: flex;
  ::v-deep.el-input__inner {
    border: none !important;
  }
  .el-button {
    border: none;
  }
}
::v-deep.el-input__inner {
  border: none !important;
}
.block {
  float: right;
  padding-right: 20px;
  padding-top: 10px;
  // margin-top: 5vh;
}
::v-deep.el-tabs--left {
  // min-height: calc(100vh - 72px);
  height: 100%;
  .el-tabs__item.is-left {
    width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-family: MicrosoftYaHei-, MicrosoftYaHei;
    font-weight: normal;
    color: #000000;
  }

  .el-tabs__item.is-active {
    background: #1795ff;
    color: #fff;
  }
}
.content_box {
  height: 100%;
  // display: flex;
  // flex-direction: column;
  .content {
    // margin: 0 auto;
    width: 100%;
    // padding: 0 2%;
    margin-top: 3px;
    background-color: #fff;
    // min-height: calc(100vh - 72px);

    .card_father {
      height: 76vh;
      /* padding-top: 10px; */
      margin-top: 10px;
      overflow: auto;
    }
    .card {
      width: 95%;
      height: 200px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
      border-radius: 8px 8px 8px 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      opacity: 1;
      margin: 20px auto;
      .card_bh {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        .card_content_top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-left: 10px;
          .card_left {
            display: flex;
          }
          .card_right {
            display: flex;
            div {
              width: 145px;
              height: 47px;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              border: 2px solid #1890ff;
              line-height: 47px;
              text-align: center;
              font-size: 18px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #1890ff;
              margin-right: 10px;
              cursor: pointer;
            }
          }
          .top_title {
            font-size: 24px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }
          .top_right {
            margin-left: 30px;
            width: 113px;
            height: 33px;
            background: #1795ff;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            font-size: 18px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 33px;
          }
        }
        .card_details {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 40px 0 10px;
          font-size: 18px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          .every {
            display: flex;
            align-items: center;
            i {
              color: #1890ff;
            }
          }
        }
      }
      .card_content {
        margin-left: 10px;
        height: 180px;
        opacity: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        span {
          color: #ccc;
        }
      }
      .card_content_center {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin-right: 30px;
      }
    }
    .card_content_bottom {
      display: flex;
      .right_content {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }
    .card_right {
      margin-right: 30px;
    }
  }
  .personal_box {
    width: 100%;
    display: flex;
    justify-content: center;
    .box_personal_content {
      width: 70%;
    }
  }
  .Personal {
    width: 40%;
  }

  ::v-deep .Personal .el-input__inner {
    width: 100%;
    border: 0;
    border-bottom: #ccc 1px solid;
    border-radius: 0;
    padding: 0;
  }
  ::v-deep.el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #000000;
  }
}
.photo {
  border-radius: 50%;
  width: 100px;
}
//
</style>



// WEBPACK FOOTER //
// src/view/Guarantee/Guarantee.vue